// 🔹 Importaciones principales
import { ButtonSiguiente } from "../../../ui";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useEffect } from "react";
import { Datos3Props } from "@/types";

type PaymentStateProps = {
  amount: number;
  status: string;
  transactionId: string | null;
};

const statusMessages: Record<string, string> = {
  succeeded: "Pago completado con éxito",
  processing: "Pago en proceso",
  requires_payment_method: "Pago fallido: método no válido",
  requires_action: "Pago requiere autenticación adicional",
  canceled: "Pago cancelado",
};

const SuccessPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    payment,
    totalPagar,
  }: {
    formData1?: Datos3Props["formData1"];
    selectedProfesiones?: string[];
    payment?: PaymentStateProps;
    totalPagar?: number;
  } = location.state || {};

  useEffect(() => {
    if (!payment) {
      navigate("/", { replace: true });
    }
  }, [payment, navigate]);

  const statusText =
    statusMessages[payment?.status ?? ""] ||
    (payment?.status === "gratis"
      ? "Suscripción activada gratuitamente"
      : "Estado desconocido");

  const isSuccess =
    payment?.status === "succeeded" || payment?.status === "gratis";

  if (!payment || !isSuccess) {
    return (
      <div className="p-8 text-center">
        <h1 className="text-2xl font-bold text-red-600 mb-4">❌ Algo salió mal</h1>
        <p>No se pudo confirmar el pago.</p>
        <Link to="/">
          <ButtonSiguiente className="mt-6 mx-auto">
            Volver al inicio
          </ButtonSiguiente>
        </Link>
      </div>
    );
  }

  // PDFs
  const pdfContratoBase64 = sessionStorage.getItem("pdfContratoBase64");
  const pdfFacturaBase64 = sessionStorage.getItem("pdfFacturaBase64");

  const numeroContrato = sessionStorage.getItem("numeroContrato");
  const numeroFactura = sessionStorage.getItem("numeroFactura");

  return (
    <div className="pt-10 dark:text-zinc-700">
      <div className="p-6 max-w-xl mx-auto text-center space-y-6">
        <h1 className="text-2xl font-bold text-green-600">
          ¡Proceso completado con éxito!
        </h1>

        <p>
          <strong>Total:</strong>{" "}
          {totalPagar !== undefined
            ? totalPagar.toFixed(2)
            : (payment.amount / 100).toFixed(2)}{" "}
          €
        </p>

        <p><strong>Estado:</strong> {statusText}</p>

      {/*   {payment.transactionId && (
          <p><strong>ID transacción:</strong> {payment.transactionId}</p>
        )} */}

        {/* 📄 CONTRATO */}
        {pdfContratoBase64 && (
          <div className="mt-4">
            <a
              href={pdfContratoBase64}
              download={`contrato_${numeroContrato ?? ""}.pdf`}
              className="text-blue-600 underline hover:text-blue-800"
            >
              Descargar Contrato PDF {numeroContrato && `(N° ${numeroContrato})`}
            </a>
          </div>
        )}

        {/* 🧾 FACTURA (solo si existe) */}
        {pdfFacturaBase64 && (
          <div className="mt-2">
            <a
              href={pdfFacturaBase64}
              download={`factura_${numeroFactura ?? ""}.pdf`}
              className="text-blue-600 underline hover:text-blue-800"
            >
              Descargar Factura PDF {numeroFactura && `(N° ${numeroFactura})`}
            </a>
          </div>
        )}

        <p className="mt-4 italic">
          Por seguridad tus datos son encriptados. ¡Gracias de parte del equipo
          de LinkServs!
        </p>

        <Link to="/">
          <ButtonSiguiente className="mt-6 mx-auto">INICIO</ButtonSiguiente>
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;
